<template>
  <modal id="confirmEmvClearingPaymentResult"
         :show="showModal"
         modal-classes="modal-dialog-centered modal-lg"
         showClose
         @close="resetForm()"
  >
    <template slot="header">
      <h4 class="modal-title">
        {{ $t('emvClearings.confirmPaymentResult.titleText') }}
      </h4>
    </template>
    <template>
      <div class="text-center text-muted mb-2">
        <small>{{ $t('emvClearings.confirmPaymentResult.helpText') }}</small>
      </div>

      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>

      <form role="form" @submit.prevent="validate()">
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('generic.description') }}</label>
          <div class="col-md-9">
            <base-input :error="getError('description')">
                <textarea class="form-control"
                          name="description"
                          data-vv-as="'description'"
                          v-validate="modelValidations.required"
                          v-model="formDetails.data.description"
                          rows="2"/>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('emvClearings.confirmPaymentResult.closeBusinessDay') }}</label>
          <div class="col-md-9">
              <base-input :error="getError('closeBusinessDay')">
                <el-date-picker
                  name="closeBusinessDay"
                  type="date"
                  v-validate="modelValidations.required"
                  v-model="formDetails.data.close_business_day"
                  :placeholder="$t('emvClearings.confirmPaymentResult.closeBusinessDayPlaceholder')"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </base-input>
          </div>
        </div>
        <div class="text-center">
          <base-button
            type="info"
            :loading="updating"
            class="my-4"
            native-type="submit"
          >{{ $t('emvClearings.confirmPaymentResult.actionBtnLabel') }}
          </base-button>
        </div>
      </form>
    </template>
  </modal>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {DatePicker, Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'confirm-emv-clearing-payment-result-dialog',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    Modal,
    BaseAlert
  },
  props: {
    formDetails: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      alert: false,
      modelValidations: {
        required: {
          required: true
        }
      },
    }
  },
  computed: {
    ...mapState({
      updating: state => state.emv_clearing.updating,
      error: state => state.emv_clearing.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
    showModal() {
      return this.show == true
    },
    pickerOptions() {
      return {
        disabledDate: (time) => {
          return time.getTime() < this.minRefundDay || time.getTime() > Date.now();
        }
      }
    },
  },
  methods: {
    ...mapActions(['UpdateEmvClearingPaymentResult']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.update()
        }
      });
    },
    removeTimezone: function (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}T00:00:00.000Z`;
    },
    update: function () {
      let out = {
        id: this.formDetails.id,
        data: {
          description: this.formDetails.data.description,
          close_business_day: this.removeTimezone(this.formDetails.data.close_business_day)
        },
      }

      this.UpdateEmvClearingPaymentResult(out).then(() => {
        if (this.error != null) {
          this.alert = true
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('emvClearings.confirmPaymentResult.updatedNotification', out),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.resetForm()
        }
      });
    },
    resetForm: function () {
      this.$emit('close');
      // resetting alerts
      this.alert = false;

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
